import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { useParams } from 'react-router-dom';
import toastr from "toastr";
// import emailverifyimg from '../assets/images/emailVerifyImg.svg';
// import linkexpireimg from '../assets/images/linkexpire.svg';
import { FormGroup } from "react-bootstrap";
import axios from "axios"
import { useDispatch } from "react-redux";
import { addNewsletterEmailRequest, sendNewsletterEmailRequest } from "store/actions";
export default function NewsLetterVerify() {

    // const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
    const { token } = useParams();
    const dispatch = useDispatch()
    const [verify, setVerify] = useState("verifying")
    const [alreadyVerified, setAlreadyVerified] = useState(false);
    const [linkExpired, setLinkExpired] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [email, setEmail] = useState()
    const [isValid, setIsValid] = useState(true);
    const [checkEmail, setCheckEmail] = useState(false)
    useEffect(() => {
        let body = {}
        body.token = token
        const callback = (response) => {
            if (response?.message === "Token not verified") {
                setVerify("failure")
                setAlreadyVerified(false)
                setEmailSent(false)
                setLinkExpired(false)
                return
            }
            if (response?.message === "Email Already Verified") {
                setVerify("failure")
                setAlreadyVerified(true)
                return
            }
            if (response?.status === "success" && response?.data === "Email verified SuccessFully") {

                setVerify('success')
            }
            else {
                return toastr.error(response?.data?.message)
            }
        }
        dispatch(addNewsletterEmailRequest(body, callback))  //  verify

    }, [token])

    const handleSubscribe = () => {
        if (email === '') {
            return toastr.error("Email is required");
        }
        if (!isValid) {
            return toastr.error("Please enter a valid Email");
        }
        let body = {}
        body.email = email
        body.marketPlace = true
        const addCallback = (response) => {
            if (response?.status === "success") {
                setEmail('')
                setCheckEmail(true)
                return toastr.success("We have sent a verification email to your inbox. Please follow the instructions to confirm your subscription to our newsletter.")
            }
            else {
                return toastr.error(response?.data?.message)
            }

        }

        dispatch(sendNewsletterEmailRequest(body, addCallback))

    }

    const handleChange = (email) => {
        setEmail(email)
        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        setIsValid(isValidEmail);

    }
    return (
        <>
            <div className="EmailVerifyBox verifiedMail">
                <div className="emailbefore">
                    <div>
                        <img src={'/images/svg/verifiedEmail.svg'} className="mx-auto mt-3 mb-4" width={400} alt="Email Verification" />
                        {alreadyVerified === true && <>
                            <h2 className="mb-2">Email already Verified</h2>
                        </>
                        }
                        {verify === "success" &&
                            <h2>Your email address has been whitelisted for the newsletter</h2>
                        }

                        {verify === "failure" && alreadyVerified === false && emailSent === false ? (
                            <>
                                {checkEmail === false ? (<>{linkExpired === false ? (<h2>Email Not Found</h2>) : (<h2>Verification link has been expired</h2>)}
                                    <FormGroup className="form-group position-relative mt-3">
                                        <input type="text" id="uploadartNew" className="form-control" placeholder="Enter Your email" name="email" value={email} onChange={(e) => { handleChange(e.target.value) }} />
                                    </FormGroup>
                                    <button className="btn btn-secondary px-5 outline-0 text-white border-0 mt-3" onClick={(e) => handleSubscribe(e.target.value)} >Resend Email</button></>) : <p>Check Your Email</p>}
                            </>
                        ) : (<>
                            {verify !== "success" && linkExpired !== false ? (
                                <>
                                    <FormGroup className="form-group position-relative mt-3">
                                        <input type="text" id="uploadartNew" className="form-control" placeholder="Enter Your email" name="email" /></FormGroup>
                                    <button className="btn btn-secondary px-5 outline-0 text-white border-0 mt-3" onClick={(e) => handleSubscribe(e.target.value)}>Resend Email</button></>)
                                : ("")}
                        </>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}